export const facturaSerieFolioFormDefault = {
    isValid: false,
    values: {
        rfc: "",
        mes: ""
    },
    touched: {
        rfc: false,
        mes: false
    },
    errors: {}
};

export const facturaSerieFolioConstraints = {
    rfc: {
        presence: {
            allowEmpty: false,
            message: '^El RFC es requerido.'
        }
    },
    mes: {
        presence: {
            allowEmpty: false,
            message: '^Campo requerido.'
        }
    }
};